module.exports = __webpack_public_path__ + "static/mind_flayer-6c9694255845d63c069b406357f3b8ab.jpg";